import mutations, { INIT_STATE } from './mutations';
import actions from './actions';
import getters from './getters';

const state = { ...INIT_STATE };

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
